<template>
  <div>
    <el-dialog
      ref="addEditDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="add_view_edit_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogAddEditForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="付款单位"
                    prop="paymentUnitId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.paymentUnitId"
                      filterable
                      clearable
                      placeholder="请选择付款单位"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in paymentUnitOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item
                    label="收款单位"
                    prop="receiveUnitId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.receiveUnitId"
                      filterable
                      clearable
                      placeholder="请选择收款单位"
                      style="width:100%"
                      @change="changeReceiveUnitFun"
                    >
                      <el-option
                        v-for="item in receiveUnitOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款银行">
                    <el-input
                      v-model="dialogAddEditForm.receiveBankName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款账号">
                    <el-input
                      v-model="dialogAddEditForm.receiveBankNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="项目编号"
                    prop="projectNo"
                  >
                    <el-input
                      v-model="dialogAddEditForm.projectNo"
                      maxlength="32"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="项目名称"
                    prop="projectName"
                  >
                    <el-input
                      v-model="dialogAddEditForm.projectName"
                      maxlength="128"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="季度"
                    prop="quarter"
                  >
                    <el-input
                      v-model="dialogAddEditForm.quarter"
                      maxlength="32"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="开始时间">
                    <el-date-picker
                      v-model="dialogAddEditForm.startDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="结束时间">
                    <el-date-picker
                      v-model="dialogAddEditForm.endDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案金额(不含税)">
                    <el-input
                      v-model="dialogAddEditForm.schemeAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="结算金额(不含税)">
                    <el-input
                      v-model="mathSettleAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="税额">
                    <el-input
                      v-model="mathTaxAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="含税金额">
                    <el-input
                      v-model="mathTotalAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="合同号"
                    prop="contractId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.contractId"
                      filterable
                      clearable
                      placeholder="请选择合同号"
                      style="width:100%"
                      @change="changeContractFun"
                    >
                      <el-option
                        v-for="item in contractOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; padding-left: 10px; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              明细信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:5px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="dialogAddEditForm.detailData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                    show-summary
                    :summary-method="receivableSummaries"
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                      align="center"
                    />
                    <el-table-column
                      prop="typeValue"
                      label="类型"
                      width="80"
                      align="center"
                    />
                    <el-table-column
                      prop="itemName"
                      label="名称"
                      width="120"
                      show-overflow-tooltip
                      header-align="center"
                    />
                    <el-table-column
                      prop="itemUnit"
                      label="单位"
                      width="80"
                      align="center"
                    />
                    <el-table-column
                      prop="schemeAmount"
                      label="方案数量"
                      width="80"
                      align="center"
                    />
                    <el-table-column
                      prop="realUsedAmount"
                      label="实际数量"
                      width="80"
                      align="center"
                    />
                    <el-table-column
                      prop="itemCount"
                      label="数量"
                      width="100"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'detailData.' + scope.$index + '.itemCount'"
                          :rules="dialogAddEditFormRules.itemCount"
                        >
                          <el-input
                            v-model="scope.row.itemCount"
                            :disabled="!scope.row.enabledEdit"
                            @input="(val)=>{limitPositiveNumber(val, scope.row, 'itemCount')}"
                            @blur="setNumberValueDefaultZero($event, scope.row, 'itemCount',4); mathItemTotalFun(scope.row)"
                          />
                        </el-form-item>
                      </template>
                    </el-table-column>
                    .<el-table-column
                      prop="itemPrice"
                      label="单价"
                      width="110"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.itemPrice"
                          :disabled="!scope.row.enabledEdit"
                          @input="(val)=>{limitPositiveNumber(val, scope.row, 'itemPrice')}"
                          @blur="setNumberValueDefaultZero($event, scope.row, 'itemPrice',4); mathItemTotalFun(scope.row)"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="taxRateValue"
                      label="税率(%)"
                      width="80"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'detailData.' + scope.$index + '.taxRateValue'"
                          :rules="dialogAddEditFormRules.taxRateValue"
                        >
                          <el-input
                            v-model="scope.row.taxRateValue"
                            disabled
                            @input="(val)=>{limitPositiveNumber(val, scope.row, 'taxRateValue')}"
                            @blur="setNumberValueDefaultZero($event, scope.row, 'taxRateValue', 4); mathItemTotalFun(scope.row)"
                          />
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="amountWithoutTax"
                      label="不含税金额"
                      width="100"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.amountWithoutTax) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="amountTax"
                      label="税额"
                      width="90"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.amountTax) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="amountIncludingTax"
                      label="含税金额"
                      width="100"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.amountIncludingTax) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="remark"
                      label="备注"
                      align="center"
                      width="150"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'detailData.' + scope.$index + '.itemRemark'"
                          :rules="dialogAddEditFormRules.itemRemark"
                        >
                          <el-input
                            v-model="scope.row.itemRemark"
                            maxlength="128"
                          />
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box pic-container">
            <h3 class="modal-title">
              附件信息
            </h3>
            <div class="modal-row-box">
              <el-upload
                ref="picUpload"
                list-type="picture-card"
                :action="picUploadAction"
                :data="picData"
                :before-upload="beforeAvatarUpload"
                :file-list="initFileList"
                :on-preview="handlePictureCardPreview"
                :headers="{'X-Token': getToken()}"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                :with-credentials="true"
                :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
              >
                <el-button
                  type="success"
                  class="upload-button"
                  icon="el-icon-folder-opened"
                >
                  选择图片
                </el-button>
              </el-upload>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="请输入备注信息"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          :disabled="operateButtonDisable"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
      <!--图片预览-->
      <el-dialog
        :visible.sync="dialogImageVisible"
        append-to-body
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { getToken, getUserId } from "@/utils/auth"
// 合同API
import { listContractApi } from '@/api/v2/contract';
import { getSettleUnitListApi } from '@/api/settleUnit'
import { initReceivableApi, saveOrUpdateReceivableApi } from '@/api/receivable'
import { initSchemeServiceItemsApi } from '@/api/materialsScheme'
// 附件
import { deleteFileApi } from '@/api/common'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
    sendObject: {
      type: Object,
      default: null
    }
  },
  data () {
    // 项目明细数量
    const validateItemCount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入明细项目数量'))
      } else {
        callback()
      }
    }
    // 项目明细税率
    const validateItemTaxRateValue = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入明细项目税率'))
        // } else if (Number(value) === 0) {
        //   callback(new Error('税率必须大于0'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      loadingText: '努力加载数据中，请耐心等待',
      operateButtonDisable: false,

      dialogAddEditForm: {
        detailData: []
      },
      dialogAddEditFormRules: {
        paymentUnitId: [{ required: true, message: '请选择付款单位', trigger: 'change' }],
        receiveUnitId: [{ required: true, message: '请选择收款单位', trigger: 'change' }],
        contractId: [{ required: true, message: '请选择合同号', trigger: 'change' }],
        projectNo: [{ required: true, message: '请输入项目编号', trigger: 'blur' }, { max: 32, message: '最多输入32个字符', trigger: 'blur' }],
        projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }, { max: 128, message: '最多输入128个字符', trigger: 'blur' }],
        quarter: [{ required: true, message: '请输入季度', trigger: 'blur' }, { max: 12, message: '最多输入12个字符', trigger: 'blur' }],
        itemCount: [{ required: true, validator: validateItemCount, trigger: ['blur', 'change'] }],
        taxRateValue: [{ required: true, validator: validateItemTaxRateValue, trigger: ['blur', 'change'] }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      paymentUnitOptions: [],
      receiveUnitOptions: [],
      contractOptions: [],
      //附件相关
      picData: { directory: 'receivableBill' },
      picUploadAction: '',
      initFileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      baseUrl: ''
    }
  },
  computed: {
    // 计算结算金额(不含税额)合计
    mathSettleAmount () {
      let bufferTotal = 0
      bufferTotal = this.dialogAddEditForm.detailData.reduce((prev, item) => {
        return this.roundNumber(prev + Number(item.amountWithoutTax), 4)
      }, 0)
      bufferTotal = this.roundNumber(bufferTotal, 2)
      return bufferTotal
    },
    // 计算税额合计
    mathTaxAmount () {
      let bufferTotal = 0
      bufferTotal = this.dialogAddEditForm.detailData.reduce((prev, item) => {
        return this.roundNumber(prev + Number(item.amountTax), 4)
      }, 0)
      bufferTotal = this.roundNumber(bufferTotal, 2)
      return bufferTotal
    },
    // 计算含税金额
    mathTotalAmount () {
      let bufferTotal = 0
      bufferTotal = this.dialogAddEditForm.detailData.reduce((prev, item) => {
        return this.roundNumber(prev + Number(item.amountIncludingTax), 4)
      }, 0)
      bufferTotal = this.roundNumber(bufferTotal, 2)
      return bufferTotal
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.operateButtonDisable = false

        this.paymentUnitOptions = []
        this.receiveUnitOptions = []
        this.contractOptions = []
        this.dialogAddEditForm = {
          provinceId: 0,
          provinceName: '',
          cityId: 0,
          cityName: '',
          sourceType: 1,
          schemeId: 0,
          projectNo: '',
          projectName: '',
          startDate: '',
          endDate: '',
          quarter: '',
          paymentUnitId: '',
          receiveUnitId: '',
          receiveBankName: '',
          receiveBankNo: '',
          schemeAmount: 0,
          settleAmount: 0,
          taxAmount: 0,
          totalAmount: 0,
          contractId: '',
          contractNo: '',
          remark: '',
          detailData: [],
          detailInfo: ''
        }
        //附件相关
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.picUploadAction = process.env.VUE_APP_BASE_API + '/web/common/uploadFile'
        this.picList = []
        this.initFileList = []

        this.initUnitSelectData()
        if (this.eventType !== 'add') {
          this.initEditData()
        } else {
          this.initAddData()
        }

        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })
      }
    }
  },
  methods: {
    getToken,
    // 初始化新增数据
    initAddData () {
      this.dialogAddEditForm = {
        provinceId: this.sendObject.provinceIds,
        provinceName: this.sendObject.provinceNames,
        cityId: this.sendObject.cityIds,
        cityName: this.sendObject.cityNames,
        sourceType: 1,
        schemeId: this.sendObject.id,
        projectNo: this.sendObject.projectNo,
        projectName: this.sendObject.name,
        startDate: this.sendObject.startDate,
        endDate: this.sendObject.endDate,
        quarter: this.sendObject.settleCycle,
        paymentUnitId: '',
        receiveUnitId: '',
        receiveBankName: '',
        receiveBankNo: '',
        schemeAmount: Number(this.sendObject.schemeAmount),
        settleAmount: 0,
        taxAmount: 0,
        totalAmount: 0,
        contractId: this.sendObject.contractId,
        contractNo: this.sendObject.contractNo,
        remark: '',
        detailData: [],
        detailInfo: ''
      }
      // 初始化合同号
      let year = this.sendObject.startDate.split("-")[0]
      this.initContractSelectData(this.sendObject.provinceIds, year, this.sendObject.id, 1)
    },
    // 加载修改数据
    initEditData () {
      initReceivableApi({ id: this.dataId }).then(res => {
        const { receivable, scheme, detailList, fileList } = res.data
        for (let key in this.dialogAddEditForm) {
          if (!receivable[key]) continue
          if (key.endsWith('Date')) this.dialogAddEditForm[key] = receivable[key + 'Value']
          else if (key.endsWith('Amount')) this.dialogAddEditForm[key] = Number(receivable[key])
          else this.dialogAddEditForm[key] = receivable[key]
        }
        this.dialogAddEditForm.id = receivable.id
        let receivableItemData = detailList || []
        receivableItemData.forEach(item => {
          item.enabledEdit = true
          if (scheme.schemeType === 4) {
            item.enabledEdit = false
          }
          if (Number(getUserId()) === 1) {
            item.enabledEdit = true
          }
        })
        this.dialogAddEditForm.detailData = receivableItemData
        // 初始化合同号
        let year = this.dialogAddEditForm.startDate.split("-")[0]
        this.initContractSelectData(this.dialogAddEditForm.provinceId, year, scheme.id, 0)
        //附件相关
        if (fileList.length > 0) {
          fileList.forEach(item => {
            let obj = {
              name: item.attachmentName, url: this.baseUrl + item.attachmentUrl, attachmentName: item.attachmentName, attachmentUrl: item.attachmentUrl
            }
            this.picList.push(obj)
            this.initFileList.push(obj)
          })
        }
        this.loading = false
      })
    },
    // 初始收款单位下拉数据
    initUnitSelectData () {
      getSettleUnitListApi({ status: 1 }).then(res => {
        res.data.forEach(item => {
          let option = { label: item.unitName, value: item.id, bankName: item.bankName, bankNo: item.bankNo }
          this.paymentUnitOptions.push(option)
          this.receiveUnitOptions.push(option)
        })
      })
    },
    // 选择收款单位回调
    changeReceiveUnitFun (val) {
      let selectItem = {}
      selectItem = this.receiveUnitOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.receiveBankName = selectItem ? selectItem.bankName : ''
      this.dialogAddEditForm.receiveBankNo = selectItem ? selectItem.bankNo : ''
    },
    // 初始合同下拉数据
    initContractSelectData (provinceId, year, schemeId, isAdd) {
      this.contractOptions = []
      listContractApi({ provinceId: provinceId, year: year }).then(response => {
        const { data } = response;
        data.forEach(item => {
          this.contractOptions.push({ label: item.code, data: item.id, name: item.name, code: item.code, manageRate: item.manageRate })
        })
        if (isAdd === 1) {
          let currentContractId = this.dialogAddEditForm.contractId
          let contractObj = this.contractOptions.find(contractItem => {
            return contractItem.data === currentContractId
          })
          // 获取方案服务项目
          initSchemeServiceItemsApi({ id: schemeId, orderSort: 'type, id asc', todoReceivable: 'true' }).then(response => {
            const { data } = response
            let serviceAmount = 0
            data.forEach(item => {
              let itemObj = {
                serviceItemId: item.id,
                type: item.type,
                typeValue: item.typeStr,
                itemName: item.itemName,
                itemUnit: item.unit,
                itemPrice: Number(item.price),
                itemCount: Number(item.receivableSettleCount),
                taxRate: item.taxRate,
                taxRateValue: Number((Number(item.taxRate) * 100).toFixed(2)),
                amountWithoutTax: this.roundNumber(Number(item.receivableSettleCount) * Number(item.price), 4),
                amountTax: 0,
                amountIncludingTax: this.roundNumber(Number(item.receivableSettleCount) * Number(item.price), 4),
                itemRemark: '',
                schemeAmount: Number(item.amount),
                realUsedAmount: Number(item.realUsedAmount),
                enabledEdit: item.enabledEdit
              }
              if (itemObj.itemName === '促销人员（按月）' || itemObj.type === 7) {
                itemObj.enabledEdit = true
              }
              serviceAmount += Number((Number(itemObj.itemPrice) * Number(itemObj.itemCount)).toFixed(4))
              if (itemObj.taxRate) {
                this.mathItemTotalFun(itemObj)
              }
              this.dialogAddEditForm.detailData.push(itemObj)
            })
            // 加入管理费明细
            let manageFee = Number(this.sendObject.manageFee)
            let mathManageFee = Number((Number(contractObj.manageRate) * Number(serviceAmount)).toFixed(4))
            if (manageFee !== mathManageFee) {
              manageFee = mathManageFee
            }
            let manageFeeItemObj = {
              serviceItemId: 0, type: 99, typeValue: '管理费', itemName: '管理费', itemUnit: '-', itemPrice: Number(manageFee),
              itemCount: 1, taxRate: 0.06, taxRateValue: 6,
              amountWithoutTax: Number(manageFee), amountTax: 0, amountIncludingTax: 0, itemRemark: '', enabledEdit: true
            }
            this.mathItemTotalFun(manageFeeItemObj)
            this.dialogAddEditForm.detailData.push(manageFeeItemObj)
            this.loading = false
          })
        }
      })
    },
    // 选择合同回调
    changeContractFun (val) {
      let selectItem = {}
      selectItem = this.contractOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditForm.contractNo = selectItem ? selectItem.label : ''
    },
    // 计算应收明细的相关金额
    mathItemTotalFun (row) {
      // 不含税金额【单价*数量】
      row.amountWithoutTax = this.roundNumber((Number(row.itemCount) * Number(row.itemPrice)).toFixed(8), 4)
      // 税率转换
      row.taxRate = this.roundNumber(Number(row.taxRateValue) / 100, 6)
      // 税额【不含税金额*税率】
      row.amountTax = this.roundNumber(Number((Number(row.amountWithoutTax) * Number(row.taxRate)).toFixed(8)), 4)
      // 含税金额【不含税金额 + 税额】
      row.amountIncludingTax = this.roundNumber((Number(row.amountWithoutTax) + Number(row.amountTax)).toFixed(8), 4)

      let manageFeeObj = this.dialogAddEditForm.detailData.find(item => {
        return item.itemName === '管理费'
      })
      if (row.itemName !== '管理费' && manageFeeObj) {
        let serviceFee = 0
        this.dialogAddEditForm.detailData.forEach(item => {
          if (item.itemName !== '管理费') {
            serviceFee += Number(item.amountWithoutTax)
          }
        })
        let contractObj = this.contractOptions.find(item => {
          return item.data === this.dialogAddEditForm.contractId
        })
        if (contractObj) {
          manageFeeObj.itemPrice = (Number(serviceFee) * Number(contractObj.manageRate)).toFixed(4)
          this.mathItemTotalFun(manageFeeObj)
        }
      }
    },
    // 应收款明细TABLE合计方法
    receivableSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'itemCount') {
          sums[index] = values.reduce((prev, curr) => {
            return Number((prev + curr).toFixed(4))
          }, 0)
          sums[index] = this.formatNumberThousandSeparator(sums[index])
        } else if (column.property === 'amountWithoutTax' || column.property === 'amountTax' || column.property === 'amountIncludingTax') {
          sums[index] = values.reduce((prev, curr) => {
            return Number((prev + curr).toFixed(2))
          }, 0)
          sums[index] = this.formatNumberThousandSeparator(sums[index])
        }
      })
      return sums
    },
    //上传前
    beforeAvatarUpload (file) {
      const isLt5M = file.size / 1024 / 1024 < 20
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过20MB!')
        return false
      }
      this.isUploading = true
    },
    // 预览
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess (res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        this.isUploading = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove (file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    // 关闭弹窗
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '应收款单信息', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            this.loading = true
            this.operateButtonDisable = true
            this.loadText = '努力保存数据中'

            this.dialogAddEditForm.settleAmount = Number(this.mathSettleAmount)
            this.dialogAddEditForm.taxAmount = Number(this.mathTaxAmount)
            this.dialogAddEditForm.totalAmount = Number(this.mathTotalAmount)
            this.dialogAddEditForm.detailInfo = JSON.stringify(this.dialogAddEditForm.detailData)

            //附件相关
            let picUrls = []
            let picNames = []
            this.picList.forEach(item => {
              picUrls.push(item.attachmentUrl)
              picNames.push(item.attachmentName)
            })
            this.dialogAddEditForm.picUrls = JSON.stringify(picUrls)
            this.dialogAddEditForm.picNames = JSON.stringify(picNames)
            this.saveOrUpdate()
          }).catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateReceivableApi(this.dialogAddEditForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
        this.operateButtonDisable = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
::v-deep .special-row .el-col {
  min-height: 20px;
}
::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
.demo-input-suffix {
  padding: 10px 0;
  .el-input {
    margin-right: 10px;
    width: 120px;
  }
  .title-sp {
    color: #1a9bff;
    margin-right: 10px;
  }
}
</style>
